import { render, staticRenderFns } from "./TaxiForm.vue?vue&type=template&id=aa090a16&"
import script from "./TaxiForm.vue?vue&type=script&lang=js&"
export * from "./TaxiForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports